import CentralDataHubSvg from 'assets/icons/navigation/central_data_hub.svg?react';

import { createAntdIcon } from 'components/icons/createAntdIcon';

export default createAntdIcon(CentralDataHubSvg, {
  displayName: 'CentralDataHubIcon',
});
